import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Offer } from '../../interfaces/offers.interface';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-offer-view',
  standalone: false,  
  templateUrl: './offer-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./offer-view.component.scss']
})
export class OfferViewComponent {
  imagesUrl = `${environment.ImagesUrl}/offer/`;
  @Input() offer?: Offer;
}
